import { PHONE_NUMBER } from "@quote/consts";
import { RoomRule } from "@quote/quote/api/init_quote/types";
import pluralize from "pluralize";

import { errorMessagesProxy } from "@/utils/helpers";

export const DEFAULT_PAX = 1;

export const DEFAULT_MAX_BOOKING_PAX = 8;

export const DEFAULT_MAX_PAX_PER_ROOM = 2;

export const MIN_PAX_PER_ROOM = 1;

export const MIN_TOTAL_PAX = 1;

export const MAX_TOTAL_PAX = 24;

export const ROOMS_ERRORS = errorMessagesProxy(
  {
    GENERIC_ERROR:
      "Sorry, there has been a problem with that request. Please try again.",

    INVALID_FOR_FOUR_BALL:
      "Please choose a multiple of 4 to book this 4-ball package",

    MAX_PAX_EXCEEDED: `For groups of more than ${MAX_TOTAL_PAX} passengers, \
                      please call our Golf Travel Experts on ${PHONE_NUMBER}.`,

    MISSING_BED_CONFIG: "Please choose a bed configuration for each room.",

    NO_PAX_SELECTED: "Please select the number of people in your party.",
  },
  {
    PAX_MISMATCH: (pax: number, total: number) => {
      const question =
        pax > total ? "Forgetting someone?" : "Someone tagging along?";
      const travellers = pluralize("traveller", pax, true);
      const verb = `${pluralize("is", total)}${pax > total ? " only" : ""}`;

      return `${question} \
              You've selected ${travellers}, but there ${verb} ${total} allocated to rooms.`;
    },
  },
);

export const STANDARD_ROOM_NAME = "Standard Room";

export const STANDARD_ROOM_RULE: RoomRule[] = [
  {
    typeName: "Standard Room",
    pricingGroupSize: 2,
    minOccupancy: 1,
    maxOccupancy: 2,
  },
];
